const API_BASE = process.env.VUE_APP_API_BASE_URI_V1;
import { HttpStatusCodes } from "@/enums";
import store from "@/store";
import router from "@/router";

export const Get = async (url, params, config) => {
  try {
    const res = await axios.get(`${API_BASE}${url}`, {
      params,
      ...config
    });
    return res;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const Post = async (url, body, config) => {
  try {
    const res = await axios.post(`${API_BASE}${url}`, body, config);
    return res;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const Put = async (url, body, config) => {
  try {
    const res = await axios.put(`${API_BASE}${url}`, body, config);
    return res;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const Delete = async (url, body, config) => {
  try {
    const res = await axios.delete(`${API_BASE}${url}`, body, config);
    return res;
  } catch (err) {
    handleErrorResponse(err);
  }
};

export const FileUpload = async (url, body, config) => {
  try {
    const instance = axios.create();
    const res = await instance.put(url, body, config);
    return res;
  } catch (err) {
    handleErrorResponse(err);
  }
};

const handleErrorResponse = err => {
  const loginPages = ["jobseeker-login", "apprentice-login"];
  const isLoginPage = loginPages.includes(router.history.current.name);
  const { response } = err;
  const { status, data } = response;
  // used store dispatch to clean all state and local storage data, instead of routing to login page only
  if (status === HttpStatusCodes.Unauthorized && !isLoginPage) {
    store.dispatch("account/logout");
  } else {
    throw data;
  }
};
